// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function ApprovedContractAvatar({ rowContractData }) {


    return (

        <Box>
            {(
            (rowContractData.comboStatus === 'a')
            &&    rowContractData.contractLevel !== 'Guild'
                && rowContractData.contractLevel !== 'Option'
                &&  rowContractData.contractLevel !== 'Cast'
                &&  rowContractData.contractLevel !== 'Engagement'
            && rowContractData.contractLevel !== 'Component Type'
            && rowContractData.contractLevel !== 'Component'
            && rowContractData.contractLevel !== 'Element Type'
            && rowContractData.contractLevel !== 'Element'
            && rowContractData.contractLevel !== 'Aspect Type'
            && rowContractData.contractLevel !== 'Aspect'
            && rowContractData.contractLevel !== 'Facet Type'
            && rowContractData.contractLevel !== 'Facet'
            && rowContractData.contractLevel !== 'Partition Type'
            && rowContractData.contractLevel !== 'Partition'
            && rowContractData.contractLevel !== 'Shard Type'
            && rowContractData.contractLevel !== 'Shard'
                )
 &&
            <div>
                <Tooltip
                    enterDelay={1000}
                    title="ApprovedContractAvatar"
                >
            <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(30,144,255)'}}>a
        </Avatar>
                </Tooltip>
</div>}
        </Box>

    )

}
